module.exports = __webpack_public_path__ + "static/media/search-image.6d2ce063.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/search-image.svg
// module id = 3247
// module chunks = 0